import { prefixClassName } from 'framework/components/ui/_conf';

export const calToolbarClx = prefixClassName('cal-toolbar');
